// extracted by mini-css-extract-plugin
export var cartIcon = "_lo-0";
export var cartIconContainer = "_lo-1";